module.exports = __webpack_public_path__ + "img/index_pic7.e70d84b6.png";